var map = {
	"./gallery1.jpg": 3843,
	"./gallery10.jpg": 6443,
	"./gallery11.jpg": 9982,
	"./gallery12.jpg": 2473,
	"./gallery13.jpg": 8748,
	"./gallery14.jpg": 2535,
	"./gallery15.jpg": 3530,
	"./gallery16.jpg": 869,
	"./gallery2.jpg": 1268,
	"./gallery3.jpg": 1217,
	"./gallery4.jpg": 7618,
	"./gallery5.jpg": 3999,
	"./gallery6.jpg": 3680,
	"./gallery7.jpg": 1773,
	"./gallery8.jpg": 8830,
	"./gallery9.jpg": 8987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4187;